
define(['module', 'translator'], function(module, translator){
	var domElements				= {};

	var methods					= {};
	var defaultLocalOptions		= { year: 'numeric', month: 'long', day: 'numeric' };


	function createConfirmModal(sStr) {
		var $modal				= methods.getDomElement('confirmModal', true);

		if(!$modal) {
			methods.getDomElement('modals').append(
				$('<div/>').attr({
					'class'			: 'modal',
					'id'			: 'confirmModal',
					'tabindex'		: '-1',
					'aria-hidden'	: 'true',
					'data-backdrop'	: 'static'
				}).append(
					$('<div/>').attr('class', 'modal-dialog modal-lg').append(
						$('<div/>').attr('class', 'modal-content').append([
							$('<div/>').attr({
								'class'			: 'modal-body',
								'id'			: 'confirmModalText'
							}).text(sStr),
							$('<div/>').attr('class', 'modal-footer').append([
								$('<button/>').attr({
									'type'				: 'button',
									'class'				: 'btn btn-light',
									'data-bs-dismiss'	: 'modal',
									'aria-label'		: 'Close'
								}).text(methods.translate('global_no')),
								$('<a/>').attr({
									'href'				: '#',
									'class'				: 'btn btn-primary',
									'id'				: 'confirmModalValid'
								}).text(methods.translate('global_yes'))
							])
						])
					)
				)
			);


			$modal				= methods.getDomElement('confirmModal', true);
		}
		else {
			methods.getDomElement('confirmModalText').text(sStr);
		}

		return $modal;
	}


	methods.translate			= function(sKey) {
		return translator.translate(sKey);
	};


	methods.getFullScreenEvent			= function() {
		var fullScreenChange;

		if ('onfullscreenchange' in window.document) {
			fullScreenChange	= 'fullscreenchange';
		} else if ('onmozfullscreenchange' in window.document) {
			fullScreenChange	= 'mozfullscreenchange';
		} else if ('onwebkitfullscreenchange' in window.document) {
			fullScreenChange	= 'webkitfullscreenchange';
		} else if ('onmsfullscreenchange' in window.document) {
			fullScreenChange	= 'MSFullscreenChange';
		}

		return fullScreenChange;
	};


	methods.consoleError		= function(message) {
		if(typeof window.console === 'object' && window.console.error) {
			console.error(message);
		}
	};


	methods.confirm				= function(sStr, callback, data) {

		var $modal				= createConfirmModal(sStr);
		if($modal) {
			var $button			= methods.getDomElement('confirmModalValid', true);
			if($button) { 

				$button.off('click.val');
				$button.on('click.val', function (event) {
					event.stopPropagation();
					if(typeof(callback) === 'function') {
						callback(data);
					}
					$modal.modal('hide');
					return false;
				});
			}

			$modal.modal('show');
			return false;
		}
		return confirm(sStr);
	};


	methods.getAlert			= function(config) {

		var sClass				= methods.getJsonData(config, 'type', 'info');
		var bDismissible		= methods.getJsonData(config, 'dismissible', false);

		var content				= [
			 $('<span/>').html(methods.getJsonData(config, 'content', ''))
		];

		if(bDismissible) {
			content.push(
				$('<button/>').attr({
					'type'				: 'button',
					'class'				: 'btn-close',
					'data-bs-dismiss'	: 'alert',
					'aria-label'		: 'Close'
				})
			);
		}

		return $('<div/>').attr({
			'class'				: 'alert alert-' + sClass + (bDismissible ? ' alert-dismissible fade show' : ''),
			'role'				: 'alert'
		}).append(content);
	};


	methods.hasFormValidation	= function() {
		return (typeof document.createElement( 'input' ).checkValidity === 'function');
	};


	methods.isFunction			= function(functionToCheck) {
		var getType = {};
		return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};


	methods.getSessionStorage	= function(sKey) {

		try {
            return JSON.parse(sessionStorage.getItem(sKey));
        } catch (err) {
			console.error(err);
            return false;
        }
	};


	methods.saveSessionStorage	= function(sKey, storage) {

		if(typeof(storage) === 'object' && typeof(sKey) === 'string') {
			sessionStorage.setItem(sKey, JSON.stringify(storage));
        }
	};


	methods.loading				= function(bAff) {
		if(bAff) {
			$('body').addClass('loading');
		}
		else {
			$('body').removeClass('loading');
		}
	};


	methods.getViewportWidth	= function() {
		return Math.max(
			document.documentElement.clientWidth,
			(window.innerWidth || 0)
		);
	},


	methods.isEmpty			= function(val) {
		return (val === null || val.length === 0);
	},


	methods.isNullJs			= function(val) {
		return (val === null);
	};


	methods.issetJs				= function(val) {
		if(typeof(val) !== 'undefined'){
			return true;
		}
		return false;
	};


	methods.checkMail			= function(sMail) {
		var mailformat			= /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return sMail.match(mailformat);
	};


	methods.getJsonData			= function(obj, key, def) {
		if($.type(obj) === 'object' && obj.hasOwnProperty(key)) {
			return obj[key];
		}

		return def;
	};


	methods.serializeForm		= function($form, bReplace) {
		var c = {},
			b = $form.serializeArray();

		$.each(b, function() {
			if (!bReplace && c[this.name]) {
				if (!c[this.name].push) {
					c[this.name] = [
						c[this.name]
					];
				}
				c[this.name].push(this.value || '');
			} else {
				c[this.name] = this.value || '';
			}
		});
		return c;
	};

	methods.filterObject	 = function(obj) {
		var ret				 = {};

		if (
			typeof obj === 'object' &&
			obj !== null &&
			!Array.isArray(obj)
		) {
			$.each(obj, function(k,v) {
				if (v !== null	&& v !== undefined  && !Number.isNaN(v)) {
					ret[k]	 = v;
				}
			});
		}

		return ret;
	  };


	methods.objectToArray		= function(obj) {
		if (
			typeof obj === 'object' &&
			obj !== null &&
			!Array.isArray(obj)
		) {
			var c				= [];
			$.each(obj, function(k,v) {
				c[k]				= v;
			});
			return c;
		} else if(Array.isArray(obj)) {
			return obj;
		}

		return [];
	};


	methods.arrayToObject		= function(arr) {
		if(Array.isArray(arr)) {
			return Object.assign({}, arr);
		}
		else if (
			typeof arr === 'object' &&
			arr !== null &&
			!Array.isArray(arr)
		) {
			return arr;
		}

		return {};
	};


	methods.getGlobal			= function(key, def) {
		return  methods.getJsonData(module.config(), key, def);
	};


	methods.resetDomElements	= function() {
		domElements				= {};
	};


	methods.getDomElement		= function(key, passTrue) {

		if(domElements.hasOwnProperty(key)) {
			return domElements[key];
		}

		return methods.getSafeDomElement(key, passTrue);
	};


	methods.getSafeDomElement	= function(key, passTrue) {

		var element				= $('#'+key);

		if(!element.length) {
			if(!passTrue) {
				throw key + ' cannot be found in the dom';
			}
			return false;
		}
		else {
			domElements[key]	= element;
			return element;
		}
	};


	methods.parseBool			= function(val) {
		return val === true || val === 'true' || val === 1 || val === '1';
	};


	methods.getReductPrice		= function(iPrice, iRate) {
		return Math.round((iPrice - (iPrice * iRate / 100)) * 100) / 100;
	};


	methods.getReduct			= function(iPrice, iRate) {
		return Math.round(iPrice * iRate) / 100;
	};


	methods.ucfirst				= function(str) {
		if (typeof str !== 'string') {
			return '';
		}
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	};


	methods.convertTitleCase	= function(str) {
		return str.replace(
		  /\w\S*/g, function(txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			}
		);
	};


	methods.cleanString			= function(str) {
		var aCh1	= ['àáâãäå', 'ç', 'èéêë', 'ìíîï', 'ðòóôõö', 'ùúûü', 'ýÿ', 'ñ'];
		var aCh2	= ['a', 'c', 'e', 'i', 'o', 'u', 'y', 'n'];
		str			= str.toLowerCase();

		$.each(aCh1, function(id, val) {
			str		= str.replace(new RegExp("["+val+"]", 'gi'), aCh2[id]);
		});

		return str;
	};


	methods.supportIntl = function() {
		return !!(typeof Intl !== 'undefined' && Intl && typeof Intl.NumberFormat !== 'undefined');
	};


	methods.isDate				= function(date) {
		return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
	};


	methods.parseDate			= function(date) {
		var pdate				= Date.parse(date);
		return isNaN(pdate) ? new Date() : new Date(pdate);
	};


	methods.getDate				= function(date) {

		 if(!methods.isDate(date)) {
			date				= methods.parseDate(date);
		 }

		 return date;
	};


	methods.formatDate			= function(date, lang, options) {

		date					= methods.getDate(date);

		if(methods.supportIntl()) {
			if(options === undefined || options === null || typeof (options) !== 'object') {
				options			=  defaultLocalOptions;
			}

			return date.toLocaleString(lang, options);
		}

		return methods.getFormatedDate(date, 'd/m/y');
	};


	methods.getMysqlDate		= function(date) {

		return methods.getFormatedDate(date, 'y-m-d');
	};


	methods.getTimestampDayValue	= function(iNbDay) {
		return (24 * 60 * 60 * 1000 * iNbDay);
	};


	methods.getDayTimestampValue	= function(iTimeStamp) {
		return Math.ceil(iTimeStamp / (24 * 60 * 60 * 1000));
	};


	methods.getFormatedDate		= function(date, format) {

		date					= methods.getDate(date);

		var sDate				= format.toLowerCase();
		var year				= date.getFullYear().toString();
		var month				= ('0' + (date.getMonth()+1).toString()).slice(-2);
		var day					= ('0' + date.getDate()).slice(-2);

		return sDate.replace('y', year).replace('m', month).replace('d', day);
	};


	methods.addDateDays			= function(date, days) {

		date					= methods.getDate(date);

		var result				= new Date(date);
		result.setDate(result.getDate() + days);

		return result;
	};


	function orderDates(date1, date2) {
		date1					= methods.getDate(date1);
		date2					= methods.getDate(date2);

		if(date1 > date2) {
			return {
				'startDate'		: date2,
				'endDate'		: date1,
				'inverse'		: true
			};
		}
		else {
			return {
				'startDate'		: date1,
				'endDate'		: date2,
				'inverse'		: false
			};
		}
	}


	methods.getNbYears			= function(date1, date2) {
		var orderedDates		= orderDates(date1, date2);
		return (orderedDates.inverse?-1:1)*(orderedDates.endDate.getFullYear()-orderedDates.startDate.getFullYear());
	};


	methods.getNbMonths			= function(date1, date2, roundUpFractionalMonths) {

		var orderedDates		= orderDates(date1, date2);

		var yearsDifference		= orderedDates.endDate.getFullYear()-orderedDates.startDate.getFullYear();
		var monthsDifference	= orderedDates.endDate.getMonth()-orderedDates.startDate.getMonth();
		var daysDifference		= orderedDates.endDate.getDate()-orderedDates.startDate.getDate();

		var monthCorrection		= 0;

		if(roundUpFractionalMonths === true && daysDifference > 0) {
			monthCorrection		= 1;
		}
		else if(roundUpFractionalMonths !== true && daysDifference < 0) {
			monthCorrection		= -1;
		}

		return (orderedDates.inverse?-1:1)*(yearsDifference*12+monthsDifference+monthCorrection);
	};

	methods.getNbDays			= function(date1, date2) {

		var orderedDates		= orderDates(date1, date2);
		var daysDifference		= orderedDates.endDate-orderedDates.startDate;
		var msInDay				= 1000 * 60 * 60 * 24;

		return (orderedDates.inverse?-1:1)*(Math.round(daysDifference/msInDay));
	};


	methods.getNbHours			= function(date1, date2) {

		var orderedDates		= orderDates(date1, date2);
		var hoursDifference		= orderedDates.endDate-orderedDates.startDate;
		var msInHour			= 1000 * 60 * 60;

		return (orderedDates.inverse?-1:1)*(Math.round(hoursDifference/ msInHour));
	};



	methods.getNbDaysInMonth	= function(month, year) {
		return new Date(year, month, 0).getDate();
	};


	methods.parseAjaxResponse	= function(json) {
		var success				= json.hasOwnProperty('success') ? methods.parseBool(json.success) : false;

		if(success && json.hasOwnProperty('data')) {

			var data			= json.data;

			return {
				data			: data,
				responsecode	: parseInt(methods.getJsonData(data, 'responsecode', 300), 10),
				message			: methods.getJsonData(data, 'message', null)
			};
		}

		return false;
	};


	methods.populateSelect		= function(select, defaultOptions, options, selectedValue) {
		$(select).empty();

		if(!methods.isNullJs(defaultOptions) && typeof(defaultOptions) === 'object') {
			$('<option></option>').attr('value', defaultOptions.key).text(defaultOptions.value).appendTo(select);
		}
		if(methods.issetJs(options) && typeof(options) === 'object') {

			var finalKey, finalValue;
			$.each(options, function(key, value){

				finalKey		= methods.getJsonData(value, 'key', key);
				finalValue		= methods.getJsonData(value, 'value', value);

				var oProp = (methods.issetJs(selectedValue) && selectedValue == finalKey) ? {'selected' : true} : {};
				$('<option></option>').attr('value', finalKey).prop(oProp).text(finalValue).appendTo(select);
			});
		}
		$(select).trigger('change');
	};


	methods.currencyFormat		= function(iPrice, sCurrency, iDecimals) {

		var prec				= !isFinite(+iDecimals) ? 2 : Math.abs(iDecimals);

		var language			= methods.getGlobal('language');
		var lang				= methods.getJsonData(language, 'lang', 'en');

		if(methods.supportIntl()) {
			return new Intl.NumberFormat(lang, { style: 'currency', currency: sCurrency, maximumFractionDigits:prec}).format(iPrice);
		}
		else {
			var pt				= Math.pow(10, prec);
			return (Math.round(iPrice * pt) / pt)+' '+sCurrency;
		}
	};


	methods.exchangePrice		= function(iPrice, iRate, sCurrency, iDecimals) {
		return methods.currencyFormat((iPrice * iRate), sCurrency, iDecimals);
	};


	methods.loadCSS				= function(src) {

		var url					= new URL(src);
		var urlParams			= new URLSearchParams(url.search);
		var date				= new Date();

		if(methods.getGlobal('mode_dev')) {
			urlParams.set('bust', date.getTime());
		}

		url.search				= urlParams.toString();
		$('head').prepend('<link rel="stylesheet" type="text/css" href="' + url.toString() + '">');
	};

	return methods;
});